import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="latlon"
export default class extends Controller {
  static targets = []
  static outlets = ["map"]
  static values = { latlon: Array }

  connect() {
  }

  latlonValueChanged() {
    this.mapOutlet.updateMarkers(this.latlonValue)
  }

  disconnect() {
  }
}
